import { Button } from "../../Control/Button/Button";
import "../../../style/icons.css";
import { ElementSelector } from "../../Filters/Card/ElementSelector";
import { TypeSelector } from "../../Filters/Card/TypeSelector";
import { CategorySelector } from "../../Filters/Card/CategorySelector";
import { JobSelector } from "../../Filters/Card/JobSelector";
import { OpusSelector } from "../../Filters/Card/OpusSelector";
import { CostSelector } from "../../Filters/Card/CostSelector";
import { FlagSelector } from "../../Filters/Card/FlagSelector";
import { TextSelector } from "../../Filters/Card/TextSelector";
import { TextSymbolSelector } from "../../Filters/Card/TextSymbolSelector";
import { PowerSelector } from "../../Filters/Card/PowerSelector";
import { RaritySelector } from "../../Filters/Card/RaritySelector";
import { CollectedSelector } from "../../Filters/Card/CollectedSelector";
import { SortBySelector } from "../../Filters/Card/SortBySelector.tsx";
import { CardFilterState } from "../../../functions/filter/CardFilterCommands.ts";
import { VariantTypeSelector } from "../../Filters/Card/VariantTypeSelector.tsx";

export type DeckBuilderFiltersProps = {
    filterState: CardFilterState,
    collection?: Record<string, number>,
    showVariantTypeFilter?: boolean,
    showVariantsFilter?: boolean,
    onApplyFilters: () => void,
    onReset: () => void,
    updateState: (updateFunction: (newFilterState: CardFilterState) => void) => void
}

export function DeckBuilderFilters(props: DeckBuilderFiltersProps) {
    return (
        <div className="w-full flex items-center flex-col">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-6xl w-full text-contrast-primary relative mb-4">
                <ElementSelector
                    values={props.filterState.elementState}
                    update={(values) => props.updateState((copy) => copy.elementState = values)}
                    isAnd={props.filterState.elementIsAnd}
                    updateIsAnd={(value) => props.updateState((copy) => copy.elementIsAnd = value)} />

                <TypeSelector
                    values={props.filterState.cardTypeState}
                    update={(values) => props.updateState((copy) => copy.cardTypeState = values)} />

                <CategorySelector
                    values={props.filterState.categoryState}
                    update={(values) => props.updateState((copy) => copy.categoryState = values)}
                    isAnd={props.filterState.categoryIsAnd}
                    updateIsAnd={(value) => props.updateState((copy) => copy.categoryIsAnd = value)} />

                <JobSelector
                    values={props.filterState.jobState}
                    update={(values) => props.updateState((copy) => copy.jobState = values)}
                    isAnd={props.filterState.jobIsAnd}
                    updateIsAnd={(value) => props.updateState((copy) => copy.jobIsAnd = value)} />

                <OpusSelector
                    values={props.filterState.opusState}
                    update={(values) => props.updateState((copy) => copy.opusState = values)} />

                <CostSelector
                    values={props.filterState.costState}
                    update={(values) => props.updateState((copy) => copy.costState = values)} />

                <PowerSelector
                    value={props.filterState.powerState}
                    update={(value) => props.updateState((copy) => copy.powerState = value)}
                    operator={props.filterState.powerComparisonSymbolState}
                    updateOperator={(value) => props.updateState((copy) => copy.powerComparisonSymbolState = value)} />

                <FlagSelector
                    values={props.filterState.flagState}
                    update={(values) => props.updateState((stateCopy) => stateCopy.flagState = values)} />

                <TextSymbolSelector
                    values={props.filterState.abilityTextSymbolState}
                    update={(values) => props.updateState((copy) => copy.abilityTextSymbolState = values)} />

                <TextSelector
                    name={props.filterState.nameText}
                    onEnterPress={props.onApplyFilters}
                    updateName={(value) => props.updateState((copy) => {
                        copy.nameText = value;
                        if (!!value) {
                            copy.searchText = null;
                        }
                    })}
                    effectText={props.filterState.effectText}
                    updateEffectText={(value) => props.updateState((copy) => {
                        copy.effectText = value;
                        if (!!value) {
                            copy.searchText = null;
                        }
                    })} />

                <RaritySelector
                    values={props.filterState.serialTypeState}
                    update={(values) => props.updateState((copy) => copy.serialTypeState = values)} />

                <CollectedSelector
                    value={props.filterState.collectedState}
                    update={(value) => props.updateState((copy) => copy.collectedState = value)}
                    operator={props.filterState.collectedComparisonSymbolState}
                    updateOperator={(value) => props.updateState((copy) => copy.collectedComparisonSymbolState = value)} />

                {
                    props.showVariantTypeFilter &&
                    <VariantTypeSelector
                        values={props.filterState.variantTypeState}
                        update={(values) => props.updateState((copy) => copy.variantTypeState = values)} />
                }

                <SortBySelector
                    value={props.filterState.sortByState}
                    update={(value) => props.updateState((copy) => copy.sortByState = value)}
                    defaultSortOptions="Opus (Desc) / Number (Asc)" />
            </div >

            <div className="sticky bottom-0 bg-secondary border-t border-t-color-border/50 rounded-b-lg grid grid-cols-2 gap-4 max-w-6xl w-full text-contrast-primary py-4 lg:-mb-6">
                <div className="flex flex-col 2xl:grid 2xl:grid-cols-[100px_1fr] 2xl:gap-6 gap-1 select-none">
                    <div></div>
                    <Button className="h-[34px]" onClick={() => props.onReset()} color="component">Reset</Button>
                </div>
                <div className="flex flex-col 2xl:grid 2xl:grid-cols-[100px_1fr] 2xl:gap-6 gap-1 select-none">
                    <div></div>
                    <Button className="h-[34px]" onClick={() => props.onApplyFilters()}>Search</Button>
                </div>
            </div>
        </div>
    )
}